module.exports = __webpack_public_path__ + "Flag-162.8f332092eac5959ec90385deee419771.svg";